import React from 'react';

import { useEffect } from 'react';

import { useNavigate, Form } from 'react-router-dom';

import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import ResourceTypeStore from '../../../stores/ResourceTypeStore';

const ResourceTypeCreatePage = ({ users }) => {
    const navigate = useNavigate();

    const store = ResourceTypeStore((state) => state);

    useEffect(() => {
        store.resetResourceType();
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('/resourceType');
                        }}
                    >
                        Back to list
                    </Button>

                    <div>ResourceType Creation Page</div>

                    <br />

                    <Form method="post" action="/resourceType/backend/create">
                        <FormGroup>
                            <FormLabel>
                                Label<span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                name="firstName"
                                type="text"
                                onChange={(e) => {
                                    store.updateAttribute(
                                        'name',
                                        e.target.value,
                                    );
                                }}
                            />
                        </FormGroup>

                        <br />
                        <br />

                        <Button
                            onClick={() => {
                                store.create(
                                    store.resourceType,
                                    () => {
                                        alert('Your resourceType was saved');
                                        navigate('/resourceType');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Create
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                navigate('/resourceType');
                            }}
                        >
                            Cancel
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default ResourceTypeCreatePage;
